import { useSeo } from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/site";
import { works } from "@/mocks/works";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import UpdatesSection from "./components/UpdatesSection";
import HotSection from "./components/HotSection";
import TopicSection from "./components/TopicSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  useSeo({
    title: "汗汗漫画悬疑推理追更专区_烧脑反转案件解密在线看",
    description:
      "汗汗漫画悬疑推理追更专区，汇集悬疑、推理、烧脑、反转、案件、解密等类型漫画，剧情反转不断，在线看追更入口，满足你的推理阅读需求。",
    keywords:
      "汗汗漫画,汗汗漫画悬疑,汗汗漫画推理,汗汗漫画烧脑,汗汗漫画反转,汗汗漫画案件,汗汗漫画解密",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
      },
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "汗汗漫画悬疑推理追更专区",
        url: siteInfo.url,
        about: ["悬疑", "推理", "烧脑", "反转", "案件", "解密"],
        hasPart: works.map((w) => ({
          "@type": "CreativeWork",
          name: w.title,
          url: `${siteInfo.url}/work/${w.id}`,
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <CategorySection />
      <UpdatesSection />
      <HotSection />
      <TopicSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}